export default "__VITE_ASSET__eTGTN7FA__"